import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { apiRequest } from '../ApiService/Allapi';
import Swal from "sweetalert2";

function PopularPage() {
    const { t, i18n } = useTranslation();
    const [pages, setPages] = useState([]);

    const Popularpage = async () => {
        const access_token = localStorage.getItem("token");
        const headers = {
            Authorization: `Bearer ${access_token}`,
        };

        try {
            const res = await apiRequest('get-popularpages', "GET", null, headers);
            if (res.status === true) {
                setPages(res.data);
            } else {
                Swal.fire("Error", res.message || "Failed to fetch blogs", "error");
            }
        } catch (error) {
            Swal.fire("Error", "Something went wrong while fetching data!", "error");
        }
    };

    useEffect(() => {
        Popularpage();
    }, []);

    return (
        <section className='tags section-padding'>
            <div className="hiring-titk">
                <h1 className="mb-4">{t("Popular")}</h1>
                <div className="container">
                    <div className="row g-0">
                        <div className="col-12"> {/* Single col-6 wrapper */}
                            <div className="link-wrap">
                                {pages.map((item) => ( // Map only creates multiple page-links
                                    <div className="page-link" key={item.id || item.slug}>
                                        <Link to={`/popular/${item.slug}`} state={{ item }} onClick={() => window.scrollTo(0, 0)}>
                                            {item.title || "Untitled"}
                                        </Link>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}

export default PopularPage;